import {useMemo} from "react";
import {objectDocumentAssocsSelector, useGetAllObjectDocumentAssocsByObjectQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {Box, Skeleton} from "@mantine/core";
import {Empty} from "../../../empty/Empty/Empty";
import {useTranslation} from "react-i18next";
import {DocumentTable} from "../DocumentTable";

export type EntityDocumentTableProps = {
  objectId: string
  showEmpty?: boolean
}

export const EntityDocumentTable = (props: EntityDocumentTableProps) => {
  const {objectId, showEmpty = true} = props

  const {t} = useTranslation(["common"])

  const selectObjectDocumentAssocs = useMemo(() => {
    return objectDocumentAssocsSelector()
  }, []);

  const {documents, isLoading} = useGetAllObjectDocumentAssocsByObjectQuery(objectId ?? skipToken, {
    selectFromResult: (result) => ({
      documents: selectObjectDocumentAssocs(result),
      isLoading: result.isLoading,
    })
  });

  return (
    <Box>
      {isLoading &&
        <>
          <Skeleton height={50} circle mb="xl"/>
          <Skeleton height={8} radius="xl"/>
          <Skeleton height={8} mt={6} radius="xl"/>
          <Skeleton height={8} mt={6} width="70%" radius="xl"/>
        </>
      }
      {(showEmpty && documents.length === 0) &&
        <Empty
          maw={400}
          h={100}
          mx="auto"
          message={t("common.action.empty.documents", "No Documents")}
        />
      }
      <DocumentTable documents={documents}/>
    </Box>
  )
}
